const guideGen42 = [
  "Neuborkia – Starter-Pokémon erhalten",
  "Mit Mami quatschen",
  "Ganz links und Hoch --> Pokedex erhalten",
  "Zurück Laufen -->Kampf gegen Rivale",
  "Zum Professor --> links aus derr Stadt und Bälle erhalten",
  "Route 29 – Erstes wildes Pokémon",
  "Rosalia City",
  "Viola City – Turm dann Arena 1",
  "Route 32 – Richtung Azalea",
  "Azalea City – Team Rocket & Arena 2",
  "Knofensa-Turm & Wald von Azalea",
  "Route 34 – Pokémon-Pension",
  "Dukatia City – Arena 3",
  "Untergrund, Radioturm & Modehaus",
  "Route 35–36 – Kräftemessen mit Sudowoodo",
  "Teak City – Türme, Rivalen-Kampf & Arena 4",
  "Route 38–39 – Kuhmuh-Milch-Farm",
  "Leuchtturm & Auftrag in Anemonia",
  "Anemonia City – Arena 5 (Wasser)",
  "Oliviana City – Arena 6 (Stahl)",
  "Mahagonia City - Arena 7",
  "Ebenholz City - Arena 8",
  "Route 40–41 – Whirlpool-Inseln",
  "Route 42 – Moosbach City",
  "Eis-Pfad & Silberbergpassage",
  "Pokémon-Liga Vorbereitung",
  "Siegesstraße – Rivalen-Kampf",
  "Pokémon-Liga – Top 4 & Champ (Lance)",
  "--- Kanto-Reise beginnt ---",
  "Route 1 – Neubeginn in Kanto",
  "Vertania City – Besuch & Durchreise",
  "Marmoria City – Arena (Gestein)",
  "Azuria City – Arena (Wasser)",
  "Vermilion City – Arena (Elektro)",
  "Lavandia – Radioturm & Story",
  "Prismania City – Arena (Pflanze)",
  "Fuchsania City – Arena (Gift)",
  "Saffronia City – Arena (Psycho)",
  "Zinnoberinsel & Seeschauminseln – Arena (Feuer)",
  "Vertania City – Arena (Boden)",
  "Route 22 – Rivale vor Indigo Plateau",
  "Pokémon-Liga Rematch",
  "Rot auf dem Silberberg – Endkampf",
];

export default guideGen42;
